import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  fetchAllRolesResponse,
  showRoleMessage,
  addAdminRoleResponse,
  addAdminRoleError,
  fetchAllPermissionsError,
  fetchAllPermissionsResponse,
} from "actions";
import api from "services/api";
import {
  ADD_ADMIN_ROLE,
  FETCH_ALL_PERMISSIONS,
  FETCH_ALL_ROLES,
} from "constants/ActionTypes";


const fetchAllRolesRequest = function*() {
  try {
    const fetchedRoles = yield call(api.get, `api/AdminRole/GetRolesAsync`);
    // debugger
    yield put(fetchAllRolesResponse(fetchedRoles));
  } catch (error) {
    // console.error('error', error)
    yield put(showRoleMessage(error));
  }
};
const addAdminRoleRequest = function*({ payload }) {
  try {
    const newAdminRole = yield call(
      api.post("api/AdminRole/CreateAdminRolesAsync", payload)
    );
    yield put(addAdminRoleResponse(newAdminRole));
  } catch (error) {
    yield put(addAdminRoleError("An error occurred in adding admin role"));
  }
};

const fetchAllPermissionsRequest = function*() {
    try {
        const fetchedPermissions = yield call(api.get, 'api/AdminRole/GetPermissionAsync')
        yield put(fetchAllPermissionsResponse(fetchedPermissions))
    } catch(error) {
        yield(fetchAllPermissionsError)
    }
}
export const addAdminRole = function*() {
  yield takeEvery(ADD_ADMIN_ROLE, addAdminRoleRequest);
};

export const fetchAllRoles = function*() {
  yield takeEvery(FETCH_ALL_ROLES, fetchAllRolesRequest);
};

export const fetchAllPermissions = function*() {
    yield takeEvery(FETCH_ALL_PERMISSIONS, fetchAllPermissionsRequest)
}
const rootSaga = function*() {
  yield all([
    fork(fetchAllRoles),
    fork(addAdminRole),
  ]);
};

export default rootSaga;
